import Vue from 'vue'
import styled from 'vue-styled-components'

Vue.prototype.$styled = styled
